// themeConfig.ts

export const customThemes = {
  light: {
    siderBg: '#2B73BC',
    headerBg: '#C9E4FF' ,
    // siderBg: '#001529',
    // headerBg: '#f0f2f5',
    hoverBg: '429FE0',
    layoutBg: '#f0f2f5',
    contentBg: '#ffffff',
    contentText: '#141414',
    footerBg: '#f0f2f5',
    textColor: '#fff',
  },
  dark: {
    siderBg: '#1f1f1f',
    headerBg: '#141414',
    layoutBg: '#141414',
    contentBg: '#141414',
    contentText: '#ffffff',
    footerBg: '#1f1f1f',
    textColor: '#000000',

  },
};
